import { bindSelectTool } from "#/admin/legacy/page-builder/select-tool.js";
import "#legacy/admin/page_builder/tool.js";
/**
 * Load lifecycle:
 *  tool.setState - used by tools with more complicated state requirements. Most tools just pass the component context to their templates, so that's the default
 *  tool.render - by default updates the tool element with markup generated by tool template, overrid for react apps
 *  tool.bind - bind events to the tool or component here
 *  tool.unbind - unbind any events
 *
 * Update lifecycle
 *  tool.setState
 *  tool.update
 *  tool.rendered (if the component was rendered)
 *
 * General Notes
 *  - render/bind/unbind are only called on load, after that it's setcontext and update. update is
 *  - identical to render by default, but you can override it. the update lifecycle is only triggered if
 *  - another tool changes the splinter, so if your tool changes a context value, you update your view there.
 */

(function () {
  "use strict";

  Sparkle.PageBuilder.Tool({
    /**
     * @description Unique identifier for the tool component.
     */
    name: "select",

    /**
     * @description The template file to use to load and render the component.
     * @see title-editor-template.hbs
     */
    templateId: "select-template",

    render: function (element, context, config) {
      var attributeConfig = config || {};
      var markup = this.template({
        context: this.context,
        config: attributeConfig,
        selectItems: attributeConfig.select_items || [],
      });
      element.innerHTML = markup;
      this.configureCustomization(element, context);
    },

    /**
     * @name bind
     * @description
     * Bind the different event listeners to the component, and also add in
     *  any extra functionality to manage the slideshow
     * @param {HTMLElement} component
     */
    bind: async function (component) {
      this.handleSelectionChange = await bindSelectTool(this.element, component);
    },

    /**
     * @name bind
     * @description
     * Unbind the different event listeners to the component added during the
     *  initial bind step.
     * @param {HTMLElement} element
     */
    unbind: function () {
      this.element.removeEventListener("change", this.handleSelectionChange);
    },
  });
})();
